import { Injectable } from '@angular/core';
import { DeskState } from '../models/deskstate.model';

@Injectable()
export class DeskStateService {

  private readonly stateKey = 'stopDeskState';

  constructor() { }

  saveState(state: DeskState): void {
    localStorage.setItem(this.stateKey, JSON.stringify(state));
  }

  loadState(): DeskState | null {
    const savedState = localStorage.getItem(this.stateKey);
    return savedState ? JSON.parse(savedState) : null;
  }

  clearState(): void {
    localStorage.removeItem(this.stateKey);
  }
}
